/**
 * DiscoveryResult is informational for Gate 1.
 * It must not hide API/DB surfaces — users can always configure access manually.
 */

export function normalizeReadinessDiscovery(discovery) {
  const src = discovery && typeof discovery === "object" ? discovery : {};
  const providers = src.providers && typeof src.providers === "object" ? src.providers : {};
  return {
    systemType: src.systemType || "unknown",
    accessMethods: Array.isArray(src.accessMethods) ? [...src.accessMethods] : [],
    providers: {
      api: providers.api ?? null,
      database: providers.database ?? null,
      vectorStore: providers.vectorStore ?? null,
    },
  };
}

/**
 * Visibility of readiness surfaces.
 * Discovery never removes a surface; "not discovered" is not "not allowed".
 */
export function gate1SurfacesForDiscovery(discovery) {
  const normalized = normalizeReadinessDiscovery(discovery);
  return {
    showApiSurface: true,
    showDbSurface: true,
    showVectorStoreSurface: true,
    showTraceSurface: false,
    discovery: normalized,
  };
}
